import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, inject } from '@angular/core';
import tippy, { Instance, Props } from 'tippy.js';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[tippy]',
  standalone: true
})
export class TippyDirective implements AfterViewInit, OnChanges, OnDestroy {
  private el = inject(ElementRef);


  @Input('tippy') content?: string | null;
  @Input() tippyProps?: Partial<Props>;

  private instance: Instance | null = null;

  ngAfterViewInit() {
    const instances = tippy(this.el.nativeElement, this.normalizeOptions({}));
    this.instance = Array.isArray(instances) ? instances[0] : instances;

    this.updateProps({
      ...this.tippyProps,
      content: this.content ?? ''
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    let props: Partial<Props> = {
      ...this.tippyProps,
      content: this.content ?? ''
    };

    if (changes['tippyProps']) {
      props = { ...(changes['tippyProps'].currentValue ?? {}), content: this.content ?? '' };
    }
    if (changes['content']) {
      props.content = changes['content'].currentValue ?? '';
    }

    this.updateProps(props);
  }

  ngOnDestroy() {
    this.instance?.destroy();
    this.instance = null;
  }

  private updateProps(props: Partial<Props>) {
    if (this.instance) {
      this.instance.setProps(this.normalizeOptions(props));

      if (!props.content) {
        this.instance.disable();
      } else {
        this.instance.enable();
      }
    }
  }

  private normalizeOptions(props: Partial<Props>): Partial<Props> {
    return {
      ...props,
      duration: props.duration ?? [50, 50]
    };
  }
}
